import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DocumentNameAvailableService {
    constructor(private httpClient: HttpClient) {}

    async checkIfDocumentNameIsExists(documentName: string, parentNodeId: number | null): Promise<boolean> {
        let url = `/v2/companyDocuments/nameAvailable?document_name=${encodeURIComponent(documentName)}`;
        if (parentNodeId) {
            url += `&parent_node_id=${parentNodeId}`;
        }

        const { available } = await this.httpClient.get<{ available: boolean }>(url).toPromise();

        return available;
    }
}
